module.exports = __webpack_public_path__ + "static/media/sense4180.9e3ca785.jpg";